
import { Role } from "./role";
export class User {
    userId: Number ;
    departmentId :Number;
    storeId: Number ;
    firstName: String ;
    userName: String ;
    lastName: String ;
    middleName: String ;
    email: String ;
    phone: String ;
    roleName: String ;
    roleModelIds: Number[] ;
    permissionModelIds:Number[] ;
    loggedinUserId:Number ;
    operatingCountryId:Number;
     cmsRoles:Role[];
     countryCode:String;
     systemUser: boolean;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/models/user.ts